/* @flow */
import * as React from 'react';
import BundleLoader from './components/BundleLoader.js';

import loadCreateComponents from 'bundle-loader?lazy!./components/create-reports/Create.js';
import loadConstellationContainerV2 from 'bundle-loader?lazy!./components/constellation/views/ConstellationView.js';
import loadBrowse from 'bundle-loader?lazy!./components/browse/Browse.js';
import loadEntitiesBrowser from 'bundle-loader?lazy!./components/browse/EntitiesBrowser/EntitiesBrowser.js';
import loadReportBrowser from 'bundle-loader?lazy!./components/browse/ReportsBrowser/ReportBrowser.js';
import loadCaseBrowser from 'bundle-loader?lazy!./components/browse/CaseBrowser.js';
import loadSearchBrowser from 'bundle-loader?lazy!./components/browse/SearchBrowser/SearchBrowser.js';
import loadPages from 'bundle-loader?lazy!trustar/components/Pages/Pages.js';
import loadCompaniesContainer from 'bundle-loader?lazy!./components/admin/Companies.js';
import loadSharingGroupsContainer from 'bundle-loader?lazy!./components/admin/SharingGroups.js';
import loadTemplatesContainer from 'bundle-loader?lazy!./components/admin/Templates.js';
import loadSubscriptionsContainer from 'bundle-loader?lazy!./components/admin/Subscriptions.js';
import loadEnclavesContainer from 'bundle-loader?lazy!./components/admin/Enclaves.js';
import loadUsersContainer from 'bundle-loader?lazy!./components/admin/Users.js';
import loadMalwareContainer from 'bundle-loader?lazy!./components/admin/iocs/MalwareSettings.js';
import loadThreatActorsContainer from 'bundle-loader?lazy!./components/admin/iocs/ThreatActorSettings.js';
import loadGlobalWhitelist from 'bundle-loader?lazy!./components/admin/iocs/GlobalWhitelistSettings.js';
import loadCompanyWhitelist from 'bundle-loader?lazy!./components/admin/iocs/CompanyWhitelistSettings.js';
import loadSettingsContainer from 'bundle-loader?lazy!./components/settings/Settings.js';
import loadApiSettingsContainer from 'bundle-loader?lazy!./components/settings/ApiSettings.js';
import loadEmailSettingsContainer from 'bundle-loader?lazy!./components/settings/EmailSettings.js';
import loadMarketplaceContainer from 'bundle-loader?lazy!./components/settings/Marketplace.js';
import loadProfileSettings from 'bundle-loader?lazy!./components/settings/ProfileSettings.js';
import loadRedactionLibrary from 'bundle-loader?lazy!./components/settings/RedactionLibrary.js';
import loadCreateForm from 'bundle-loader?lazy!./components/create-reports/CreateForm.js';
import loadReview from 'bundle-loader?lazy!./components/create-reports/Review.js';
import loadCreateIndicators from 'bundle-loader?lazy!./components/create-indicators/CreateIndicators.js';
import loadLogin from 'bundle-loader?lazy!./components/auth/views/Login.js';
import loadLogout from 'bundle-loader?lazy!./components/auth/views/Logout.js';
import loadEnsureLogin from 'bundle-loader?lazy!./components/auth/views/EnsureLogin.js';
import loadMfa from 'bundle-loader?lazy!./components/auth/views/Mfa.js';
import loadTermsAgreement from 'bundle-loader?lazy!./components/auth/views/TermsAgreement.js';
import loadCreatePassword from 'bundle-loader?lazy!./components/auth/views/CreatePassword.js';
import loadForgotPassword from 'bundle-loader?lazy!./components/auth/views/ForgotPassword.js';
import loadAuthContainer from 'bundle-loader?lazy!./components/auth/views/AuthContainer.js';
import loadNotificationSettings from 'bundle-loader?lazy!./components/settings/NotificationSettings.js';
import loadSSOReceiver from 'bundle-loader?lazy!./components/auth/views/SSOReceiver.js';
import loadErrorView from 'bundle-loader?lazy!./components/errors/ErrorView.js';
import loadPhishingView from 'bundle-loader?lazy!./components/phishing/views/ConnectedPhishingView.js';

/**
 * Lazily load a bundle provided by the webpack bundle-loader. Bundles imported
 * with bundle-loader are functions. They take one argument which is a callback
 * that will be called with the component once loaded.
 */
class Bundle extends React.Component {
  props: {
    load: (mod: Object) => void,
    children: (mod: Object) => React.Element<*>
  };

  // short for "module" but that's a keyword in js, so "mod"
  state = {
    mod: null
  };

  // Default to true to avoid unforseen breakage (might be hard to debug by
  // anyone unaware of the lazy loading). React should handle not allowing
  // setState _before_ mount, but we need to make sure our async callbacks
  // aren't called _after unmount_. Therefore we only update this in
  // componentWillUnmount
  mounted: boolean = true;

  componentWillMount() {
    this.load(this.props);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.load !== this.props.load) {
      this.load(nextProps);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  load(props) {
    this.setState(() => ({ mod: null }));
    props.load(mod => {
      if (this.mounted) {
        this.setState(() => ({
          // handle both es imports and cjs
          mod: mod.default ? mod.default : mod
        }));
      }
    });
  }

  render() {
    return this.state.mod ? (
      this.props.children(this.state.mod)
    ) : (
      <BundleLoader />
    );
  }
}

/**
 * The Bundles. These are... repetitive. But creating a wrapper function results
 * in React being unable to resolve a component name, so for now this is what's
 * happening.
 */
export const CreateContainer = (props: Object) => (
  <Bundle load={loadCreateComponents}>
    {Comp => <Comp.CreateContainer {...props} />}
  </Bundle>
);

export const ErrorView = (props: Object) => (
  <Bundle load={loadErrorView}>{Comp => <Comp {...props} />}</Bundle>
);

export const UpdateContainer = (props: Object) => (
  <Bundle load={loadCreateComponents}>
    {Comp => <Comp.UpdateContainer {...props} />}
  </Bundle>
);

export const CreateForm = (props: Object) => (
  <Bundle load={loadCreateForm}>{Comp => <Comp {...props} />}</Bundle>
);

export const Review = (props: Object) => (
  <Bundle load={loadReview}>{Comp => <Comp {...props} />}</Bundle>
);

export const CreateIndicators = (props: Object) => (
  <Bundle load={loadCreateIndicators}>{Comp => <Comp {...props} />}</Bundle>
);

export const SettingsContainer = (props: Object) => (
  <Bundle load={loadSettingsContainer}>{Comp => <Comp {...props} />}</Bundle>
);

export const ApiSettingsContainer = (props: Object) => (
  <Bundle load={loadApiSettingsContainer}>{Comp => <Comp {...props} />}</Bundle>
);

export const EmailSettingsContainer = (props: Object) => (
  <Bundle load={loadEmailSettingsContainer}>
    {Comp => <Comp {...props} />}
  </Bundle>
);

export const MarketplaceContainer = (props: Object) => (
  <Bundle load={loadMarketplaceContainer}>{Comp => <Comp {...props} />}</Bundle>
);

export const ProfileSettings = (props: Object) => (
  <Bundle load={loadProfileSettings}>{Comp => <Comp {...props} />}</Bundle>
);

export const RedactionLibrary = (props: Object) => (
  <Bundle load={loadRedactionLibrary}>{Comp => <Comp {...props} />}</Bundle>
);

export const CompanyWhitelist = (props: Object) => (
  <Bundle load={loadCompanyWhitelist}>{Comp => <Comp {...props} />}</Bundle>
);

export const CompaniesContainer = (props: Object) => (
  <Bundle load={loadCompaniesContainer}>{Comp => <Comp {...props} />}</Bundle>
);

export const SharingGroupsContainer = (props: Object) => (
  <Bundle load={loadSharingGroupsContainer}>
    {Comp => <Comp {...props} />}
  </Bundle>
);

export const TemplatesContainer = (props: Object) => (
  <Bundle load={loadTemplatesContainer}>{Comp => <Comp {...props} />}</Bundle>
);

export const SubscriptionsContainer = (props: Object) => (
  <Bundle load={loadSubscriptionsContainer}>
    {Comp => <Comp {...props} />}
  </Bundle>
);

export const EnclavesContainer = (props: Object) => (
  <Bundle load={loadEnclavesContainer}>{Comp => <Comp {...props} />}</Bundle>
);

export const UsersContainer = (props: Object) => (
  <Bundle load={loadUsersContainer}>{Comp => <Comp {...props} />}</Bundle>
);

export const EntitiesBrowser = (props: Object) => (
  <Bundle load={loadEntitiesBrowser}>{Comp => <Comp {...props} />}</Bundle>
);

export const GlobalWhitelist = (props: Object) => (
  <Bundle load={loadGlobalWhitelist}>{Comp => <Comp {...props} />}</Bundle>
);

export const ConstellationContainerV2 = (props: Object) => (
  <Bundle load={loadConstellationContainerV2}>
    {Comp => <Comp {...props} />}
  </Bundle>
);

export const Browse = (props: Object) => (
  <Bundle load={loadBrowse}>{Comp => <Comp {...props} />}</Bundle>
);

export const MalwareContainer = (props: Object) => (
  <Bundle load={loadMalwareContainer}>{Comp => <Comp {...props} />}</Bundle>
);

export const ThreatActorsContainer = (props: Object) => (
  <Bundle load={loadThreatActorsContainer}>
    {Comp => <Comp {...props} />}
  </Bundle>
);

export const ReportBrowser = (props: Object) => (
  <Bundle load={loadReportBrowser}>{Comp => <Comp {...props} />}</Bundle>
);

export const CaseBrowser = (props: Object) => (
  <Bundle load={loadCaseBrowser}>{Comp => <Comp {...props} />}</Bundle>
);

export const SearchBrowser = (props: Object) => (
  <Bundle load={loadSearchBrowser}>{Comp => <Comp {...props} />}</Bundle>
);

export const PageContainer = (props: Object) => (
  <Bundle load={loadPages}>{Comp => <Comp {...props} />}</Bundle>
);

export const About = (props: Object) => (
  <Bundle load={loadPages}>{Comp => <Comp.About {...props} />}</Bundle>
);

export const Help = (props: Object) => (
  <Bundle load={loadPages}>{Comp => <Comp.Help {...props} />}</Bundle>
);

export const Terms = (props: Object) => (
  <Bundle load={loadPages}>{Comp => <Comp.Terms {...props} />}</Bundle>
);

export const Tours = (props: Object) => (
  <Bundle load={loadPages}>{Comp => <Comp.Tours {...props} />}</Bundle>
);

export const NotFound = (props: Object) => (
  <Bundle load={loadPages}>{Comp => <Comp.NotFound {...props} />}</Bundle>
);

export const Login = (props: Object) => (
  <Bundle load={loadLogin}>{Comp => <Comp {...props} />}</Bundle>
);

export const Logout = (props: Object) => (
  <Bundle load={loadLogout}>{Comp => <Comp {...props} />}</Bundle>
);

export const EnsureLogin = (props: Object) => (
  <Bundle load={loadEnsureLogin}>{Comp => <Comp {...props} />}</Bundle>
);

export const Mfa = (props: Object) => (
  <Bundle load={loadMfa}>{Comp => <Comp {...props} />}</Bundle>
);

export const TermsAgreement = (props: Object) => (
  <Bundle load={loadTermsAgreement}>{Comp => <Comp {...props} />}</Bundle>
);

export const CreatePassword = (props: Object) => (
  <Bundle load={loadCreatePassword}>{Comp => <Comp {...props} />}</Bundle>
);

export const ForgotPassword = (props: Object) => (
  <Bundle load={loadForgotPassword}>{Comp => <Comp {...props} />}</Bundle>
);

export const SSOReceiver = (props: Object) => (
  <Bundle load={loadSSOReceiver}>{Comp => <Comp {...props} />}</Bundle>
);

export const AuthContainer = (props: Object) => (
  <Bundle load={loadAuthContainer}>{Comp => <Comp {...props} />}</Bundle>
);

export const NotificationSettings = (props: Object) => (
  <Bundle load={loadNotificationSettings}>{Comp => <Comp {...props} />}</Bundle>
);

export const PhishingView = (props: Object) => (
  <Bundle load={loadPhishingView}>{Comp => <Comp {...props} />}</Bundle>
);



// WEBPACK FOOTER //
// ./src/app/BundleCreator.js